module.exports = __webpack_public_path__ + "fc5b7660f8d42e20caf01415ea83b23a.elite.png";


//////////////////
// WEBPACK FOOTER
// ./components/productVariants/rankPickers/mobileLegends/assets/elite.png
// module id = FvB8
// module chunks = 0